import { useIntl } from "react-intl";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { useMountEffect } from "primereact/hooks";
import { Field } from "react-final-form";
import { resetState } from "../../../store/slices/authSlice";
import { TextInput } from "../../common/fields";
import Form from "../../common/form";
import * as Validations from "../../common/form/validator";
import { RouteConstants } from "../../../constants";
import PreLoginContainer from "../../common/preLoginContainer";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  CompanySignInButton,
  CompanySignInRedirecting,
  useCompanySignInRedirect,
} from "../sso/CompanySignIn";

export const Login = ({ requesting, action, resetState, global }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useMountEffect(() => {
    resetState();
  });

  const passwordOff = useCompanySignInRedirect(global?.enterprise);

  const userName =
    (searchParams.get("params") &&
      atob(decodeURIComponent(searchParams.get("params")))) ||
    null;

  if (passwordOff) {
    return <CompanySignInRedirecting enterprise={global?.enterprise} />;
  }

  return (
    <PreLoginContainer showLoginMessage={true}>
      <div className="title text-center">
        {intl.formatMessage({
          id: "sign_in",
        })}
      </div>
      <CompanySignInButton enterprise={global?.enterprise} />
      <Form
        initialValues={{
          username: userName || Cookies.get("username") || "",
        }}
        fullWidthButtons
        requesting={action === "sign-in" && requesting}
        submitBtn={{
          label: intl.formatMessage({
            id: "sign_in_password",
          }),
          icon: "pi-arrow-right",
          onClick: (values) => {
            navigate(RouteConstants.APP_ROUTE_LOGIN_LOCAL, {
              state: { username: values.username },
            });
          },
        }}
        extraBtn={{
          label: intl.formatMessage({
            id: "sign_in_otp",
          }),
          shouldValidate: true,
          // One filled button: the code is the second way in
          outlined: true,
          icon: "pi-arrow-right",
          onClick: (values) => {
            navigate(RouteConstants.APP_ROUTE_OTP, {
              state: { username: values.username },
            });
          },
        }}
      >
        <div className="flex flex-column gap-2 mt-4">
          <Field
            name="username"
            component={TextInput}
            type="text"
            icon="pi-user"
            label={intl.formatMessage({ id: "username" })}
            placeholder={intl.formatMessage({
              id: "username",
            })}
            required
            validate={Validations.composeValidators(Validations.required)}
          />
        </div>
      </Form>
      {global?.enterprise?.isSelfRegistrationEnabled && (
        <div className="text-center mt-4">
          <span className="text-600">
            {intl.formatMessage({ id: "dont_have_account" })}
          </span>{" "}
          <span
            className="text-primary cursor-pointer"
            onClick={() => navigate(RouteConstants.APP_ROUTE_SIGN_UP)}
            style={{ textDecoration: "underline" }}
          >
            {intl.formatMessage({ id: "sign_up" })}
          </span>
        </div>
      )}
    </PreLoginContainer>
  );
};

const mapStateToProps = (state) => ({
  requesting: state.auth.requesting,
  error: state.auth.error,
  action: state.auth.action,
  global: state.global,
});

const mapDispatchToProps = (dispatch) => ({
  resetState: () => dispatch(resetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
